import { React, useEffect, useRef, useState } from "react";
import { Box, Button, Typography, Container, Snackbar, Alert } from "@mui/material";
import { useNavigate } from "react-router-dom";
import StepProgress from './StepProgress';
import { useAuth } from "../context/AuthContext";
import gb from '../assets/images/gbottom.png';
import CircularProgress from "@mui/material/CircularProgress";

import { motion } from "framer-motion";
import NotLoggedIn from "../components/LoginExceptions";
// ✅ Common Variables
const RAZORPAY_KEY = "rzp_test_R1E4A2whW7RqSn"; // Replace with your Razorpay Test Key ID
const API_BASE_URL = "https://gcp-poc-with-apollo-1081525845464.asia-south1.run.app";
// const API_BASE_URL = "http://localhost:8080";
const PaymentScreen = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const paymentContainer = useRef(null);
    const [orderId, setOrderId] = useState(null);
    const [finalAmount, setFinalAmount] = useState(null);
    const [snackbarMessage, setSnackbarMessage] = useState("");
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [loadingPayment, setLoadingPayment] = useState(false);

    const storedUserType = localStorage.getItem("user_type");



 

    const handleCloseSnackbar = () => {
        setOpenSnackbar(false);
    };



    const fetchOrder = async () => {
        setLoadingPayment(true); // Start loading

        try {
            const amount = 2000;
            const mobile = localStorage.getItem("mobile");

            // Making a call to your backend to create the Razorpay order
            const response = await fetch(`${API_BASE_URL}/create-order`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ amount, mobile }) // Send amount for the order creation
            });

            if (!response.ok) {
                throw new Error(`Server Error: ${response.status}`);
            
            }
            setLoadingPayment(false);

            const orderData = await response.json();
            console.log("Order Data:", orderData);

            if (!orderData.orderId || !orderData.amount) {
                throw new Error("Invalid order response");
            }

            // Set orderId and amount (in paise)
            setOrderId(orderData.orderId);
            setFinalAmount(orderData.amount);
        } catch (error) {
            console.error("Error fetching order:", error);
            alert("Failed to create order. Please try again.");
            setLoadingPayment(false);
        }
    };


    useEffect(() => {
        const mobile = localStorage.getItem("mobile");

        if (orderId && finalAmount && paymentContainer.current) {
            const options = {
                key: RAZORPAY_KEY,
                amount: finalAmount,
                currency: "INR",
                name: "TKS Trust",
                description: "UPI QR Payment",
                order_id: orderId,
                image: "/CWA_logo.png", // 🔹 Add a custom logo
                theme: {
                    color: "#FFA500", // 🔹 Primary brand color

                    hide_topbar: false, // 🔹 Show/hide the top bar
                },
                modal: {
                    backdropclose: false, // 🔹 Prevent closing by clicking outside
                    confirm_close: true, // 🔹 Ask for confirmation before closing
                    animation: true, // 🔹 Smooth opening animation
                },
                handler: async function (response) {
                    console.log("Payment Successful:", response);

                    localStorage.setItem("payment_completed", "true");

                    const mobile = localStorage.getItem("mobile");

                    // Now, instead of calling Google Apps Script, we'll call your backend to verify payment
                    const verifyParams = new URLSearchParams({
                        paymentId: response.razorpay_payment_id, // Razorpay Payment ID
                        orderId: orderId, // Order ID
                    }).toString();

                    try {
                        const verifyResponse = await fetch(`${API_BASE_URL}/verify-payment`, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                            },
                            body: JSON.stringify({
                                paymentId: response.razorpay_payment_id,
                                orderId: orderId,
                                signature: response.razorpay_signature, // Include signature if needed for verification
                            }),
                        });

                        const verifyData = await verifyResponse.json();
                        setSnackbarMessage(verifyData.message); // Show success/error message
                        setSnackbarOpen(true);
                        window.location.href = '/receipt';
                    } catch (error) {
                        console.error("Error verifying payment:", error);
                        setSnackbarMessage("Payment verification failed.");
                        setSnackbarOpen(true);
                    } finally {
                        setLoadingPayment(false); // Stop loading in both success & error
                    }
                },


                payment_capture: 1,
                method: {
                    upi: true,
                    netbanking: true,
                    card: true,
                },
                upi: {
                    flow: "collect",
                },
                prefill: {
                    contact: mobile,
                },
                container: paymentContainer.current, // Embed inside this div
            };

            const razorpay = new window.Razorpay(options);
            razorpay.open();
        }
    }, [orderId, finalAmount]);

    if (!storedUserType) {
        return <NotLoggedIn />;
    }

    return (
        <Box
            sx={{
                minHeight: "100vh",
                background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                px: 2,
                position: "relative",
                overflow: "hidden",
            }}
        >
            <Container maxWidth="sm">
                <motion.div
                    initial={{ opacity: 0, y: 60 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, ease: "easeOut" }}
                >
                    <Box
                        sx={{
                            backdropFilter: "blur(10px)",
                            backgroundColor: "rgba(255,255,255,0.75)",
                            boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
                            borderRadius: 4,
                            p: 4,
                            textAlign: "center",
                        }}
                    >

                        <Typography
                            variant="h5"
                            sx={{ fontWeight: "bold", color: "#2A289C", mb: 2 }}
                        >
                            One-Time Payment of ₹2000
                        </Typography>
                        <Typography sx={{ mb: 4, color: "#555" }}>
                            Your payment is safe and secure. Please complete the transaction to
                            proceed.
                        </Typography>

                        <motion.div
                            whileHover={{ scale: 1.05 }}
                            whileTap={{ scale: 0.97 }}
                            transition={{ type: "spring", stiffness: 300 }}
                        >
                            <Button
                                variant="contained"
                                onClick={fetchOrder}
                                disabled={loadingPayment}
                                sx={{
                                    background: "linear-gradient(90deg, #28a745, #218838)",
                                    px: 4,
                                    py: 1.5,
                                    fontWeight: "bold",
                                    borderRadius: 3,
                                    fontSize: "16px",
                                    "&:hover": {
                                        background: "linear-gradient(90deg, #218838, #1e7e34)",
                                    },
                                }}
                            >
                                {loadingPayment ? <CircularProgress size={24} color="inherit" /> : "Proceed to Pay"}
                            </Button>

                        </motion.div>

                        <Box
                            ref={paymentContainer}
                            id="razorpay-container"
                            sx={{ mt: 2, width: "100%", height: "0px" }}
                        />

                        <Typography
                            variant="body2"
                            sx={{ mt: 4, color: "#7A7841", fontSize: "14px" }}
                        >
                            For transactions other than ₹2000, please contact TKS Admin at
                            <br />
                            <strong>+91 9841818740</strong> or{" "}
                            <a href="mailto:tsct041224@gmail.com">tsct041224@gmail.com</a>
                        </Typography>

                        <motion.div
                            initial={{ opacity: 0, scale: 0.9 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ delay: 0.3 }}
                        >
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "center",
                                    gap: 2,
                                    mt: 4,
                                }}
                            >
                                <Button
                                    variant="contained"
                                    onClick={() => {navigate("/profile");window.scrollTo(0, 0);}}
                                    sx={{
                                        backgroundColor: "#6C757D",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        "&:hover": {
                                            backgroundColor: "#5a6268",
                                        },
                                    }}
                                >
                                    Back
                                </Button>
                                <Button
                                    variant="contained"
                                    onClick={() => {navigate("/");window.scrollTo(0, 0);}}
                                    sx={{
                                        backgroundColor: "#E52029",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        "&:hover": {
                                            backgroundColor: "#c71c23",
                                        },
                                    }}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </motion.div>
                    </Box>
                </motion.div>

                {/* Snackbar Alert */}
                <Snackbar
                    open={openSnackbar}
                    autoHideDuration={3000}
                    onClose={handleCloseSnackbar}
                    anchorOrigin={{ vertical: "top", horizontal: "center" }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: -10 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.3 }}
                    >
                        <Alert
                            onClose={handleCloseSnackbar}
                            severity="success"
                            sx={{
                                width: "100%",
                                fontSize: "16px",
                                fontWeight: "bold",
                                boxShadow: "0 0 12px rgba(0,0,0,0.1)",
                            }}
                        >
                            Payment Completed Successfully!
                        </Alert>
                    </motion.div>
                </Snackbar>
            </Container>

            {/* Decorative Footer Image */}
            <motion.div
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.5 }}
            >
                <Box
                    sx={{
                        position: "absolute",
                        bottom: 0,
                        left: 0,
                        width: { xs: "120px", sm: "400px" },
                        height: { xs: "40px", sm: "150px" },
                        backgroundImage: `url(${gb})`,
                        backgroundRepeat: "no-repeat",
                        backgroundSize: "contain",
                        backgroundPosition: "left bottom",
                    }}
                />
            </motion.div>
        </Box>
    );
};
export default PaymentScreen;
